let ApplicationContext  = require("../config/ApplicationContext.js");

class HubsUtil {

	constructor(){}

    getHubId(pathname){
        let path = this.handleString(this.handleString(pathname).sliceFrom("hubs/"));
        let end = pathname.length;
        
        if(path.search("-")) {
            end = path.search("-")
        }else if(path.search("/")) {
            end = path.search("/")
        }
        return path.sliceTo(end)
    }

    getHubName(pathname){
        let path = this.handleString(this.handleString(pathname).sliceFrom("hubs/"));
        
        if(path.lastSearch("/")) {
            path = this.handleString(this.handleString(path.get()).sliceTo(path.lastSearch("/")))
        }

        if(path.search("-")) {
            path = this.handleString(this.handleString(path.get()).sliceFrom("-"))
        }else if(path.search("/")) {
            path = this.handleString(this.handleString(path.get()).sliceFrom("/"))
        }else{
            path = {get: () => ""};
        }

        if(path.get() === ""){ return ""}
        
        return decodeURIComponent(path.get());
    }

    
    setUpHubUrl(currentHub, history, tab){
        const { id, name } = currentHub;
        const pathname = this.getRealPathname(location.href);

        if (this.checkTab(pathname, tab, "/packages")) {
            history.replace({ pathname: `/hubs/${id}-${encodeURIComponent(name)}/packages` });
        } else if (this.checkTab(pathname, tab, "/3dmodels")) {
            history.replace({ pathname: `/hubs/${id}-${encodeURIComponent(name)}/3dmodels` });
        } else if (this.checkTab(pathname, tab, "/trash")) {
            history.replace({ pathname: `/hubs/${id}-${encodeURIComponent(name)}/trash` });
        } else if (this.checkTab(pathname, tab, "/libraries") || !/(\/packages|\/libraries|\/3dmodels)/gi.test(pathname)) {
            if (this.checkTab(pathname, tab, "/manageMembers")) {
                history.replace({ pathname: `/hubs/${id}-${encodeURIComponent(name)}/libraries`, search: "?manageMembers=true" });
            } else {
                history.replace({ pathname: `/hubs/${id}-${encodeURIComponent(name)}/libraries` });
            }
        }
    }


    isOwner(hub){
        return hub.owner.id === ApplicationContext.getUserData().id;   
    }

    checkTab(pathname, tab, name){
        return tab === name || pathname.includes(name)
    }

    getRealPathname(href){
        return this.handleString(href).sliceFrom(location.origin)
    }

    handleString(string){
        return {
            get: () => string,
            sliceTo: end => string.slice(0, end),
            sliceFrom: character => string.slice(string.indexOf(character)+character.length),
            search: character => string.indexOf(character) === -1 ? false: string.indexOf(character),
            lastSearch: character => string.lastIndexOf(character) === -1 ? false: string.lastIndexOf(character)
        }
    }


    getDefaultHub(hubs){
        return  hubs.reduce((accum, hub) => {
                    if(hub.isDefault){ accum = hub }
                    return accum;
                }, null)
    }

    typeUser(entitlements){
        if (entitlements.includes("urn:autodesk.com:services:eaglepremium"))
            return "premium";
        else if (entitlements.includes("urn:autodesk.com:services:eagleeducation"))
            return "education";
        else if (entitlements.includes("urn:autodesk.com:services:eaglestandard"))
            return "standard";
        else
            return "free";
    }
}

module.exports = new HubsUtil();
